import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Divider,
  Button,
} from "@mui/material";
import { withStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.bubble.css";

const UpdatePreview = ({
  imagePreviewUrl,
  title,
  classes,
  shortDescription,
  date,
  html_content,
  buttontext,
}) => {
  const { t } = useTranslation();

  // Determine the image source (file or URL)
  const imageSrc =
    imagePreviewUrl instanceof File
      ? URL.createObjectURL(imagePreviewUrl) // Generate URL for file object
      : imagePreviewUrl; // Use the URL directly

  return (
    <div>
      <div className={classes.container}>
        <Typography className={classes.previewText}>
          {t("updates_create.update_preview_title")}
        </Typography>
        <Card className={classes.card}>
          <CardMedia className={classes.cardMedia} image={imageSrc} />
          <CardContent className={classes.cardContent}>
            <Typography className={classes.title}>{title}</Typography>
            <Typography className={classes.description}>
              {shortDescription}
            </Typography>
            <Typography className={classes.date}>{date}</Typography>
          </CardContent>
          <Divider />
        </Card>
      </div>
      <div className={classes.containerDetail}>
        <Typography className={classes.previewText}>
          {t("updates_create.update_preview_details")}
        </Typography>
        <Card className={classes.updateDetail}>
          <CardMedia className={classes.cardMedia} image={imageSrc} />
          <CardContent
            className={`${classes.cardContent} ${classes.cardContentHeight}`}
          >
            <Typography className={classes.title}>{title}</Typography>
            <ReactQuill
              className={classes.quill}
              value={html_content}
              readOnly={true}
              theme="bubble"
            />
          </CardContent>
          {buttontext && (
            <div className={classes.buttonContainer}>
              <Button className={classes.rsvpButton}>{buttontext}</Button>
            </div>
          )}
        </Card>
      </div>
    </div>
  );
};

UpdatePreview.defaultProps = {
  shortDescription: "",
};

UpdatePreview.propTypes = {
  template: PropTypes.object.isRequired,
  imagePreviewUrl: PropTypes.string.isRequired,
  customValues: PropTypes.object,
  classes: PropTypes.object.isRequired,
  shortDescription: PropTypes.string,
};

const styles = (theme) => ({
  container: {
    position: "relative",
    left: 72,
    maxWidth: 260,
  },
  containerDetail: {
    marginTop: 30,
    position: "relative",
    left: 72,
    maxWidth: 260,
  },
  cardContentHeight: {
    flex: 1,
    overflow: "auto",
  },
  updateDetail: {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    height: 640,
  },
  card: {
    maxWidth: "260px",
    marginTop: 10,
  },
  cardMedia: {
    aspectRatio: "16/9",
    margin: "8px 8px 0 8px",
  },
  title: {
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "14px",
  },
  description: {
    fontWeight: 200,
    fontSize: "10px",
    color: "#8E8E93",
    lineHeight: "12px",
  },
  date: {
    fontWeight: 300,
    fontSize: "8px",
    color: "#8E8E93",
    lineHeight: "10px",
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  previewText: {
    Size: 14.5,
    letterSpacing: 0,
    marginBottom: 15,
    fontWeight: "bold",
    lineHeight: 1,
  },
  quill: {
    marginLeft: 0,
    padding: 0,
    marginTop: 8,
    marginBottom: 10,
    "& .ql-editor": {
      padding: 0,
      fontSize: 10,
      color: "#505055",
    },
    "& .ql-tooltip": {
      display: "none",
    },
  },

  buttonContainer: {
    padding: "20px 10px",
    backgroundColor: "#f4f4f4",
    width: "100%",
  },
  rsvpButton: {
    backgroundColor: "#000000",
    color: "#FFFFFF",
    fontSize: 10,
    width: "100%",
    fontWeight: 600,
    textTransform: "none",
    padding: "8px",
    "& .MuiButton-label": {
      fontWeight: 600,
    },
  },
});

export default withStyles(styles)(UpdatePreview);
